import React, { useEffect } from "react";
import "./Order_summery_holder.css";
import { Badge, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Blue_Round_Btn from "../../common-components/common-btn/blue_round_btn/Blue_Round_Btn";
import { getAllWalletHistory } from "../../../features/wallet/walletSlice";
import { useDispatch, useSelector } from "react-redux";
import Green_Btn from "../../common-components/common-btn/green_btn/Green_Btn";
import GST_modal from "../../common-components/common-modals/gst_modal/GST_modal";

function Order_summery_holder({
  btnText,
  handleClick,
  orderSumary,
  setRewardData,
  rewardData,
  error,
  disable,
  errorMessage,
  setGSTNumber,
  GSTNumber,
  Checkout,
  footerContent,
}) {
  const [modalShow, setModalShow] = React.useState(false);
  const dispatch = useDispatch();
  const wallet = useSelector((state) => state.wallet.allWalletHistory);
  useEffect(() => {
    dispatch(getAllWalletHistory({}));
  }, [dispatch]);

  // Combine product tax + lens tax into a single "Total Tax" figure.
  const totalTax =
    Number(orderSumary?.order_summary?.total_tax || 0) +
    Number(orderSumary?.order_summary?.total_lense_tax || 0);

  return (
    <>
      <section className="Order_summery_holder">
        <div className="heading_holder">
          <h6>Order Summary</h6>
        </div>
        <div className="Order_summery_table">
          <div className="table-responsive">
            <Table>
              <tbody>
                <tr>
                  <td>Total MRP</td>
                  <td className="value_text">
                    ₹ {orderSumary?.order_summary?.total_mrp}
                  </td>
                </tr>

                <tr>
                  <td>Discount</td>
                  <td className="value_text">
                    ₹ {orderSumary?.order_summary?.total_discount}
                  </td>
                </tr>

                <tr>
                  <td>Total Tax</td>
                  <td className="value_text">
                    ₹ {totalTax.toFixed(2)}
                  </td>
                </tr>

                <tr>
                  <td>Coupon Discount</td>
                  <td className="value_text">
                    ₹-{orderSumary?.order_summary?.total_coupon_discount}
                  </td>
                </tr>

                {/* NEW: shipping charge (depends on the selected address country) */}
                <tr>
                  <td>Shipping Charges</td>
                  <td className="value_text">
                    ₹{" "}
                    {Number(
                      orderSumary?.order_summary?.total_delivery_charges || 0,
                    ).toFixed(2)}
                  </td>
                </tr>

                {!disable && (
                  <tr>
                    <td>
                      Reward Points
                      <p className="price_available_text">
                        (₹{Number(wallet?.user_wallet?.amount || 0).toFixed(2)}{" "}
                        {rewardData ? "Used" : "available"} )
                      </p>
                      <h6>
                        <Badge
                          bg={rewardData ? "danger" : "secondary"}
                          onClick={() => setRewardData(!rewardData)}
                          style={{ cursor: "pointer" }}
                        >
                          {rewardData ? "Remove" : "Apply"}
                        </Badge>
                      </h6>
                    </td>

                    <td className="value_text">
                      ₹-{orderSumary?.order_summary?.reward_discount}
                    </td>
                  </tr>
                )}

                <tr className="total_tr_holder">
                  <td>Total</td>
                  <td className="value_text">
                    ₹{Math.round(orderSumary?.order_summary?.total_amount || 0)}
                  </td>
                </tr>

                {Checkout && (
                  <tr className="align-items-center">
                    <td>
                      <div className="d-flex justify-content-center align-items-center"></div>
                      GST Number
                    </td>
                    <td className="value_text p-0">
                      <div className="row-divider">
                        <div className="qty_div">
                          <Green_Btn
                            onClick={() => setModalShow(true)}
                            btn_name="GST Number"
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </div>
        <div className="btn_holder ">
          <Blue_Round_Btn btnText={btnText} onClick={handleClick} />
        </div>

        {/* Shown right below Pay Now (used by Checkout for the Terms checkbox) */}
        {footerContent}

        {errorMessage && (
          <p className="text-danger text-center mt-2">{errorMessage}</p>
        )}
        {error && (
          <div style={{ color: "red", textAlign: "center", marginTop: "10px" }}>
            {error}
          </div>
        )}

        <GST_modal
          GSTNumber={GSTNumber}
          setGSTNumber={setGSTNumber}
          show={modalShow}
          onHide={() => setModalShow(false)}
        />
      </section>
    </>
  );
}

export default Order_summery_holder;